import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { DictionaryEntry } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { DocumentTemplateDetails, TemplateArea } from '../../document-template-administration-model';
import { DocumentTemplateEditorService } from '../../document-template-editor.service';

const MAX_GRID_COLUMNS = 10;
const NUMBER_OF_CHOICES = 3;

@Component({
    selector: 'app-template-area-details',
    templateUrl: './template-area-details.component.html',
    styleUrls: ['./template-area-details.component.scss'],
    standalone: false
})
export class TemplateAreaDetailsComponent {

  choiceOptions = new Array<string>();

  templateDetails: DocumentTemplateDetails = new DocumentTemplateDetails();

  details: TemplateArea = new TemplateArea();

  detailsFormGroup: FormGroup;

  @Output() deleteTemplateArea = new EventEmitter<TemplateArea>();

  @Input() set template(templateDetails: DocumentTemplateDetails) {
    this.templateDetails = templateDetails;
  }

  @Input() set templateArea(templateArea: TemplateArea) {
    this.details = templateArea;

    const values = {
      choice: this.details.choice,
      columnCount: this.details.columnCount,
      style: this.details.style,
    };
    this.detailsFormGroup.reset(values);
  }

  constructor(
    private editorService: DocumentTemplateEditorService,
    public translationService: TranslationService) {
    this.initializeDetailsForm();
  }

  public onTitleDataDictionaryChanged(dictionaryEntry: DictionaryEntry) {
    // Object neu erzeugen damit change detection und somit überstzungspipe reagieren
    this.details.title = new DictionaryEntry(dictionaryEntry);
    this.templateDetails.dirty = true;
    this.templateDetails.validate();
  }

  public onHelpDataDictionaryChanged(dictionaryEntry: DictionaryEntry) {
    // Object neu erzeugen damit change detection und somit überstzungspipe reagieren
    this.details.help = new DictionaryEntry(dictionaryEntry);
    this.templateDetails.dirty = true;
    this.templateDetails.validate();
  }

  private initializeDetailsForm() {

    for (let i = 1; i <= NUMBER_OF_CHOICES; i++) {
      this.choiceOptions.push('' + i);
    }

    this.detailsFormGroup = new FormGroup({
      choice: new FormControl('', []),
      columnCount: new FormControl('', [Validators.required]),
      style: new FormControl('', [Validators.required]),
    });

    this.detailsFormGroup.valueChanges.subscribe(
      values => {
        if (this.detailsFormGroup.dirty) {
          const v = this.detailsFormGroup.getRawValue();
          this.details.choice = v.choice;
          let columnCount = v.columnCount;
          if (columnCount < 1) {
            columnCount = 1;
            this.detailsFormGroup.controls.columnCount.setValue(columnCount, { onlySelf: true, emitEvent: false });
          } else if (columnCount > 10) {
            columnCount = MAX_GRID_COLUMNS;
            this.detailsFormGroup.controls.columnCount.setValue(columnCount, { onlySelf: true, emitEvent: false });
          }
          if (this.details.columnCount !== columnCount) {
            this.details.columnCount = columnCount;
            this.editorService.updateAreaAfterChanges(this.details);
          }
          this.details.style = v.style;
          this.templateDetails.dirty = true;
          this.templateDetails.validate();
        }
      }
    );
  }

  public deleteArea() {
    this.deleteTemplateArea.next(this.details);
    this.templateDetails.dirty = true;
    this.templateDetails.validate();
  }
}
